import { get, del, post, put } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const getCurrencyList = () => get(url.CURRENCY_DEFINITIONS)
export const addCurrency = record => post(url.CURRENCY_INSERT, record)
export const updateCurrency = record => put(url.CURRENCY_UPDATE, record)
export const deleteCurrency = guid => del(url.CURRENCY_DELETE, { params: { guid } })